import Component from '../core/Component';

export default class Form extends Component {

    constructor($element) {
        super($element);
        this.$inputs = this.$element.find('input:required');
        this.$button = this.$element.find('[data-ref-form-submit]');
    }

    prepare() {
        this.$inputs.on('change', event => {
            setTimeout(function() {
                this.checkFilled();
            }.bind(this), 0);
        });

        this.checkFilled();
    }

    checkFilled() {
        let disabled = false;

        $.each(this.$inputs, (index, item) => {
            if (item.type == "text") {
                if (item.value.length == 0) {
                    disabled = true;
                }
                if (item.classList.contains('has-error')) {
                    disabled = true;
                }
            } else if (item.type == "checkbox") {
                if (!item.checked) {
                    disabled = true
                }
            }
        });

        if (disabled) {
            this.$button.addClass('disabled');
        } else {
            this.$button.removeClass('disabled');
        }

    }

}


// WEBPACK FOOTER //
// ./components/Form.js